import { virtualModel__core_server_side_action_definitions } from '../virtualModels/core_server_side_action_definitions'

export const useServerSideFlowsFeature = () => {
  $core.$appHook.on('CORE.frontApp.beforeInit', () => {
    $core.$virtualModelsLoader.loadModel(
      virtualModel__core_server_side_action_definitions,
    )
  })
}
